import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=0e408b98&scoped=true&"
import script from "./VideoAdd.vue?vue&type=script&lang=ts&"
export * from "./VideoAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e408b98",
  null
  
)

export default component.exports